import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateProjectExpenseRequestFailure() {
      return getState().isFailure;
    },
    isCreateProjectExpenseRequestPending() {
      return getState().isPending;
    },
    isCreateProjectExpenseRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
